import { NotificationService } from '@cradua/core';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, concatMap, exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as ClusterCommunityActions from './cluster-community.actions';
import { ClusterCommunityService } from '../../services/cluster-community.service';

@Injectable()
export class ClusterCommunityEffects {
  loadClusterCommunity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ClusterCommunityActions.loadClusterCommunity),
      exhaustMap((_) =>
        this.clusterService.getClusterCommunity().pipe(
          map((data) =>
            ClusterCommunityActions.loadClusterCommunitySuccess({
              clusterCommunity: data,
            })
          ),
          catchError((error) =>
            of(ClusterCommunityActions.loadClusterCommunityFailure({ error }))
          )
        )
      )
    )
  );

  addClusterCommunity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ClusterCommunityActions.addClusterCommunity),
      concatMap(({ newClusterCommunity }) =>
        this.clusterService.createClusterCommunity(newClusterCommunity).pipe(
          map((data) => {
            this.notification.success('Saved Successfully');
            return ClusterCommunityActions.addClusterCommunitySuccess({
              newClusterCommunity: data,
            });
          }),
          catchError((error) =>
            of(
              ClusterCommunityActions.addClusterCommunityFailure({
                error: error.error.message,
              })
            )
          )
        )
      )
    )
  );

  updateClusterCommunity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ClusterCommunityActions.updateClusterCommunity),
      map((action) => action.updateClusterCommunity),
      concatMap((updateClusterCommunity) =>
        this.clusterService.updateClusterCommunity(updateClusterCommunity).pipe(
          map((_) => {
            this.notification.success('Updated Successfully');
            return ClusterCommunityActions.updateClusterCommunitySuccess({
              updateClusterCommunity: updateClusterCommunity,
            });
          }),
          catchError((error) =>
            of(
              ClusterCommunityActions.updateClusterCommunityFailure({
                error: error.message,
              })
            )
          )
        )
      )
    )
  );

  removeClusterCommunity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ClusterCommunityActions.removeClusterCommunity),
      map((action) => action.ids),
      concatMap((ids) =>
        this.clusterService.deleteClusterCommunity(ids).pipe(
          map(() => {
            this.notification.success('Deleted Successfully');
            return ClusterCommunityActions.removeClusterCommunitySuccess({
              ids,
            });
          }),
          catchError((error) =>
            of(
              ClusterCommunityActions.updateClusterCommunityFailure({
                error: error.message,
              })
            )
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private clusterService: ClusterCommunityService,
    private notification: NotificationService
  ) {}
}
